import {Tabs} from '@mantine/core';
import {PersonalPanel} from "./panels/PersonalPanel";
import {ContactPanel} from "./panels/ContactPanel";
import {LocationPanel} from "./panels/LocationPanel";
import {PhotoPanel} from "./panels/PhotoPanel";
import {BusinessPanel} from "./panels/BusinessPanel";
import {SocialPanel} from "./panels/SocialPanel";


export const FormComponent = () => {

    return (
        <Tabs defaultValue={'personal'}>
            <Tabs.List>
                <Tabs.Tab value='personal'>Personal</Tabs.Tab>
                <Tabs.Tab value='contact'>Contact</Tabs.Tab>
                <Tabs.Tab value='location'>Location</Tabs.Tab>
                <Tabs.Tab value='photo'>Photo</Tabs.Tab>
                <Tabs.Tab value='social'>Social</Tabs.Tab>
                <Tabs.Tab value='business'>Business</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value='personal'>
                <PersonalPanel/>
            </Tabs.Panel>
            <Tabs.Panel value='contact'>
                <ContactPanel/>
            </Tabs.Panel>
            <Tabs.Panel value='location'>
                <LocationPanel/>
            </Tabs.Panel>
            <Tabs.Panel value='photo'>
                <PhotoPanel/>
            </Tabs.Panel>
            <Tabs.Panel value='social'>
                <SocialPanel/>
            </Tabs.Panel>
            <Tabs.Panel value='business'>
                <BusinessPanel/>
            </Tabs.Panel>
        </Tabs>
    );
};
